import '@/i18n'

import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'

import { Providers } from '@/providers'
import type { QueryClient } from '@tanstack/react-query'
import { useRTL } from '@/hooks'

// Create a no-op component for prod
const Noop = () => null
// In dev, lazy-load the devtools module. In prod, use Noop.
// Because `import.meta.env.DEV` is a compile-time constant, Vite will
// tree-shake the devtools and their deps out of the prod build.
const Devtools = import.meta.env.DEV
  ? lazy(() => import('@/integrations/tanstack-query/devtools'))
  : Noop

interface MyRouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  useRTL()
  return (
    <>
      <Providers>
        <Outlet />
        <Suspense fallback={null}>
          <Devtools />
        </Suspense>
      </Providers>
    </>
  )
}
